// extracted by mini-css-extract-plugin
export default {"title_box":"ModalMain_title_box__224wU","children":"ModalMain_children__PgLLG","button_box":"ModalMain_button_box__YG5EK"};